// Lib
import React from 'react';

// Components
import Toast from '../../structural/toast/Toast';
import Icon from '../icons/Icon';

// Styles
import './ErrorToast.scss';

type ErrorToastProps = {
    /** The error message to display */
    message?: string | null;
    /** Whether to show the toast */
    show: boolean;
    /**
     * Optional parent container class for modal-aware positioning.
     * When provided, the toast will be positioned relative to the modal instead of the app bottom.
     * Example: "ShareModal", "ImageModal", etc.
     */
    groupId?: string;
    /** Callback function called when the toast is dismissed by clicking */
    onDismiss?: () => void;
};

const ErrorToast: React.FC<ErrorToastProps> = ({ message, show, groupId, onDismiss }) => {
    if (!show) {
        return null;
    }

    const handleClick = () => {
        if (onDismiss) onDismiss();
    };

    return (
        <Toast className="ErrorToast" groupId={groupId} onClick={handleClick}>
            <Icon name="error-alert-round" />
            <span className="ErrorMessage">{message}</span>
        </Toast>
    );
};

export default ErrorToast;
